import Ledger from "@/views/accountants/Ledger"
import CostTypeSettings from "@/views/settings/CostTypesSettings"
import LedgerCategoriesTable from "@/components/accountants/LedgerCategoriesTable"
import Customers from "@/views/accountants/Customers"
import CustomerOverview from "@/components/accountants/CustomerOverview"
import ControlPanel from "@/views/accountants/ControlPanel"
import BalanceSheet from "@/views/gekko/BalanceSheet"
import CostTypesSettings from "@/views/settings/CostTypesSettings"
import DownloadData from "@/views/settings/DownloadData"
import TaxreportList from "@/views/gekko/TaxreportList"
import FinancialReporting from "@/views/gekko/FinancialReporting"
import Taxreport from "@/views/gekko/Taxreport"
import Costs from "@/views/gekko/Costs"
import Invoices from "@/views/gekko/Invoices"
import EditCost from "@/components/costs/EditCost"
import TaxReturn from "@/components/accountants/tax_return/TaxReturn.vue";
import Files from "@/views/gekko/Files";
import BankConnection from "@/views/accountants/BankConnection";


const routes = [
  {
    path: '/:language/accountants/ledger/', name: 'Ledger', component: Ledger, meta: { title: 'Ledger' }, pathToRegexpOptions: { strict: true }, children: [
      { path: '', component: CostTypeSettings, name: 'Ledger', meta: { title: 'Ledger' } },
      { path: 'ledger-categories', component: LedgerCategoriesTable, name: 'LedgerCategoriesTable', meta: { title: 'Ledger Categories' } }
    ]
  },
  {
    path: '/:language/accountants/customers/', name: 'Customers', component: Customers, meta: { title: 'Customers' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'overview/:customerId', component: CustomerOverview, name: 'CustomerOverview', meta: { title: 'Customer Overview' } }
    ]
  },
  { path: '/:language/accountants/control-panel/:customerId/summary/', name: 'ControlPanelSummary', component: ControlPanel, meta: { title: 'Summary' }, pathToRegexpOptions: { strict: true }, children: [] },
  {
    path: '/:language/accountants/control-panel/:customerId/invoices/', name: 'ControlPanelInvoices', component: Invoices, meta: { title: 'Invoice' }, pathToRegexpOptions: { strict: true }, children: [
      {
        path: 'upload/',
        name: 'ControlPanelInvoiceUpload',
        meta: { title: 'Upload to Invoices', showUploadModal: true, modalType: 'upload' },
        children: [
          {
            path: 'invoice/add', name: 'ControlPanelInvoiceUploadInvoice',
            meta: {
              title: 'Upload Invoice',
              showUploadModal: true,
              modalType: 'upload',
              uploadType: 'invoice'
            }
          },
          {
            path: 'correction/add', name: 'ControlPanelInvoiceUploadCorrection',
            meta: {
              title: 'Upload Correction',
              showUploadModal: true,
              modalType: 'upload',
              uploadType: 'correction'
            }
          },
          {
            path: 'edit/:invoiceId',
            name: 'ControlPanelInvoiceEdit',
            meta: {
              title: 'Edit Invoice',
              masterModal: 'edit'
            }
          },
          {
            path: 'payment/:invoiceId',
            name: 'ControlPanelInvoicePayments',
            meta: {
              title: 'Invoice payments',
              masterModal: 'payments'
            }
          },
        ]
      },
    ]
  },
  {
    path: '/:language/accountants/control-panel/:customerId/costs/', name: 'ControlPanelCosts', component: Costs, meta: { title: 'Costs' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'edit/:costId/', component: EditCost, name: 'ControlPanelEditCost', meta: { title: 'Edit costs', masterModal: 'edit' } },
      { path: 'add/', component: EditCost, name: 'ControlPanelAddCost', meta: { title: 'Add cost' } }
    ]
  },
  { path: '/:language/accountants/control-panel/:customerId/vat/', name: 'ControlPanelVAT', component: TaxreportList, meta: { title: 'VAT report' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/vat/create/', component: Taxreport, name: 'ControlPanelCreateVAT', meta: { title: 'Create report' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/vat/view/:id/', component: Taxreport, name: 'ControlPanelViewVAT', meta: { title: 'View report' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/investments/', name: 'ControlPanelInvestments', component: BalanceSheet, meta: { title: 'Balance Sheet Investments' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/financial-statements/', name: 'ControlPanelFinancialStatements', component: FinancialReporting, meta: { title: 'Financial Statements' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/costtypes/', name: 'ControlPanelCostTypes', component: CostTypesSettings, meta: { title: 'Cost types' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/tax-return/', name: 'ControlPanelTaxReturn', component: TaxReturn, meta: { title: 'Tax return' }, pathToRegexpOptions: { strict: true }, children: [] },
  { path: '/:language/accountants/control-panel/:customerId/export/', name: 'ControlPanelExport', component: DownloadData, meta: { title: 'Download your data' }, pathToRegexpOptions: { strict: true }, children: [] },
  {
    path: '/:language/accountants/control-panel/:customerId/files/', name: 'ControlPanelFiles', component: Files, meta: { title: 'Files' }, pathToRegexpOptions: { strict: true }, children: [
      { path: '/:language/accountants/control-panel/:customerId/files/:id/', name: 'ControlPanelFileDetails', component: Files, meta: { title: 'File Details', showModal: true } }
    ]
  },
  { path: "/:language/accountants/control-panel/:customerId/bank-connection/", name: "BankConnectionAccountant", component: BankConnection, meta: { title: 'Bank Connection' } },
]

export default routes